import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const Priority = lazy(() => import('./Priority.jsx'))       

const PriorityRoutes = [
    {
        path: '/Priority',
        component: Priority,
        auth: authRoleAccess.case_priority,
    },
   
]

export default PriorityRoutes 